// src/components/CatylexSearch/catylexCardStyles.ts
// Shared style definitions for Catylex result cards (contracts and sentences).

import React from "react";
import { catylexColors } from "./catylexSearchStyles";

export const emptyStateStyle: React.CSSProperties = {
  padding: "16px 12px",
  fontSize: "12px",
  color: catylexColors.mutedForeground,
  textAlign: "center",
  fontStyle: "italic",
};

export const containerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "8px",
};

export const cardStyle: React.CSSProperties = {
  padding: "10px 12px",
  borderRadius: "6px",
  border: `1px solid ${catylexColors.border}`,
  backgroundColor: "white",
};

export const headerRowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "flex-start",
  gap: "10px",
};

export const titleColStyle: React.CSSProperties = {
  flex: 1,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  gap: "2px",
};

export const titleRowStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

export const titleStyle: React.CSSProperties = {
  fontSize: "13px",
  fontWeight: 600,
  color: catylexColors.foreground,
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  flex: 1,
  minWidth: 0,
};

export const fileNameStyle: React.CSSProperties = {
  fontSize: "11px",
  color: catylexColors.mutedForeground,
  margin: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const getStatusStyle = (status: string): React.CSSProperties => ({
  fontSize: "10px",
  fontWeight: 500,
  padding: "2px 6px",
  borderRadius: "4px",
  backgroundColor:
    status.toLowerCase() === "active" ? catylexColors.activeBg : "rgba(220, 53, 69, 0.1)",
  color:
    status.toLowerCase() === "active" ? catylexColors.activeColor : catylexColors.inactiveColor,
  whiteSpace: "nowrap",
  flexShrink: 0,
});

export const reportLinkStyle: React.CSSProperties = {
  background: "none",
  border: "none",
  padding: "2px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  borderRadius: "4px",
  opacity: 0.8,
};

export const fieldGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  columnGap: "8px",
  rowGap: "3px",
  marginTop: "8px",
  fontSize: "11px",
  lineHeight: "1.4",
};

export const fieldLabelStyle: React.CSSProperties = {
  color: catylexColors.mutedForeground,
  fontWeight: 500,
  whiteSpace: "nowrap",
};

export const fieldValueStyle: React.CSSProperties = {
  color: catylexColors.foreground,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const summaryStyle: React.CSSProperties = {
  fontSize: "11px",
  color: catylexColors.mutedForeground,
  marginTop: "4px",
};
